import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getTablePaginationUtilityClass(slot) {
  return generateUtilityClass("MuiTablePagination", slot);
}
const tablePaginationClasses = generateUtilityClasses("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
const tablePaginationClasses$1 = tablePaginationClasses;
export {
  tablePaginationClasses$1 as default,
  getTablePaginationUtilityClass
};
//# sourceMappingURL=tablePaginationClasses.es.js.map
